import React from 'react';
import { observer } from 'mobx-react-lite';

import styled from '@emotion/styled';
import { css } from 'emotion';

import pluralize from 'pluralize';

import { useStore } from '@vromo/mobx-react';

import FontAwesome from '@vromo/ui/components/FontAwesome';
import Title from '@vromo/ui/components/Title';
import theme from '@vromo/ui/components/theme';

import { InfoCard } from './InfoCard';
import { RootStore } from '../stores/RootStore';

const SegmentRow = styled.div`
    display: flex;
    flex-direction: row;

    @media (max-width: 1000px) {
        flex-direction: column;
    }
`;

interface Props {
    loading?: boolean;
}

export default observer<Props>(function LiveStats({ loading }) {
    const rootStore = useStore<RootStore>('rootStore');

    const { jobStore, vehicleStore } = rootStore;

    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center', marginLeft: '20px' }}>
                <Title>Live Stats</Title>
                <FontAwesome
                    icon="satellite-dish"
                    weight="solid"
                    className={css`
                        font-size: 1.5em;
                        padding: 10px;
                        margin-top: 17px;
                        animation: pulse 2s infinite;
                        opacity: 0.7;

                        @keyframes pulse {
                            0% {
                                color: ${theme.text.dark};
                            }
                            50% {
                                color: #ff4136;
                            }
                            100% {
                                color: ${theme.text.dark};
                            }
                        }
                    `}
                />
            </div>
            <SegmentRow>
                <InfoCard
                    icon="route"
                    colour="#43C96E"
                    quantity={loading ? '-' : jobStore.underway.length}
                    label={`${pluralize('Job', jobStore.open.length)} Underway`}
                />
                <InfoCard
                    icon="exclamation-triangle"
                    colour="#FFB02E"
                    quantity={loading ? '-' : jobStore.atRisk.length}
                    label={`${pluralize('Job', jobStore.atRisk.length)} at Risk`}
                />
                <InfoCard
                    icon="pencil"
                    colour="#BC1818"
                    quantity={loading ? '-' : jobStore.unassigned.length}
                    label={`Unassigned ${pluralize('Job', jobStore.unassigned.length)}`}
                />
                <InfoCard
                    icon="car-side"
                    colour="#43C96E"
                    quantity={loading ? '-' : vehicleStore.availableDrivers.length}
                    label={`${pluralize('Driver', vehicleStore.availableDrivers.length)} Online`}
                />
            </SegmentRow>
        </div>
    );
});
